<template>
  <el-row type="flex" justify="space-between">
    <el-col :span="4">
      <p class="title"><strong>{{ label }}</strong></p>
      <p v-html="row.SE"></p>
    </el-col>
    <el-col :span="6">
      <p class="title"><strong>Request Info</strong></p>
      <p v-html="row.RequestInfo"></p>
    </el-col>
    <el-col :span="6">
      <p class="title"><strong>Notes</strong></p>
      <div class="expand-notes" v-html="row.Notes"></div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "expand-for-pushed",
  props: {
    label: String,
    row: Object
  }
}
</script>

<style scoped lang="scss">
p {
  font-weight: normal;
  line-height: 24px;
  color: #606266;

  &.title {
    font-size: 14px;
    color: #000;
  }
}

.expand-notes {
  line-height: 20px;

  strong {
    width: 100px;
    display: inline-block;
  }
}
</style>